import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { ChatComponent } from '@features/chat/chat.component';
import { HeaderComponent } from '@features/header/header.component';
import { UIService } from '@core/services/ui.service';
import { MaintenanceService } from '@core/services/maintenance.service';
import { SvgIconComponent } from 'angular-svg-icon';
import { DISCORD_LINK } from '@core/constants/discord.constants';
import { environment } from '@environments/environment';
import { CoinflipSpritesService } from '@old-app/coinflip/coinflip-sprites.service';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, HeaderComponent, ChatComponent, SvgIconComponent],
  standalone: true,
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppComponent {
  readonly uiService = inject(UIService);
  readonly maintenanceService = inject(MaintenanceService);
  readonly DISCORD_LINK = DISCORD_LINK;
  readonly version = environment.version;
  // Construct the sprite service at app boot so the coinflip atlas decode +
  // ImageBitmap upload runs in parallel with the rest of bootstrap. By the
  // time a user reaches a coinflip the bitmaps are typically resident.
  private readonly coinflipSprites = inject(CoinflipSpritesService);
}
